import { fetchData } from "./utils"; // Adjust the import path based on your folder structure

// Fetch all users with optional query parameters (e.g., pagination, filtering)
export const fetchUsers = async ({ skip = 0, limit = 10 } = {}) => {
    try {
        return await fetchData("users", skip, limit); // Call fetchData with the "users" endpoint
    } catch (error) {
        console.error("Error fetching users:", error.message);
        throw error; // Re-throw the error for the calling function to handle
    }
};

// Example: Fetch specific user by ID
export const fetchUserById = async (userId) => {
    try {
        return await fetchData(`users/${userId}`); // Call fetchData with a dynamic endpoint
    } catch (error) {
        console.error(`Error fetching user with ID ${userId}:`, error.message);
        throw error;
    }
};